import { render, staticRenderFns } from "./TotalOrderLogs.vue?vue&type=template&id=8cb85366"
import script from "./TotalOrderLogs.vue?vue&type=script&lang=js"
export * from "./TotalOrderLogs.vue?vue&type=script&lang=js"
import style0 from "./TotalOrderLogs.vue?vue&type=style&index=0&id=8cb85366&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports